/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconBrokenHeart: {
  name: 'broken_heart';
  data: string;
} = {
  name: 'broken_heart',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M446.412 30.473c-40.011-.077-80.818 16.07-112.882 51.585l44.488 173.507-39.968.037 42.247 157.893-139.516-225.166 59.803 6.425-58.533-138.208C143.96-1.718 5.684 48.279 10.16 189.039c5.261 165.48 228.539 220.656 295.728 396.395 70.973-175.754 300.334-220.333 294.831-396.395-3.065-98.066-77.217-158.417-154.307-158.566z"/></svg>`,
};
